import { BillingInfo, CountrySubdivision } from '@citrite/sf-api';
import { Col, Form, Input } from 'antd';
import { t } from '../../translate';
import {
	AddressField,
	addressFieldId,
	addressFieldStatus,
	getAddressFieldStatus,
	getRequiredFields,
} from './addressField';
import { SearchSelect } from './SearchSelect';

interface ValidationMessages {
	required?: string;
	invalid?: string;
}

export interface GetStateOrProvinceFieldProps {
	addressInfo: BillingInfo;
	addressField: AddressField;
	validationMessages?: ValidationMessages;
	subdivisions?: CountrySubdivision[];
	disableEditing?: boolean;
	testIdPrefix?: string;
}

export const GetStateOrProvinceField = (props: GetStateOrProvinceFieldProps) => {
	const dependencies = getRequiredFields(props.addressField, props.addressInfo);
	const fieldStatus = getAddressFieldStatus(props.addressField, dependencies);

	if (fieldStatus === addressFieldStatus.hidden || props.subdivisions?.length === 0) {
		return null;
	}

	return (
		<Col span={props.addressField.colWidth}>
			<SearchSelect
				addressFieldId={props.addressField.id}
				required={fieldStatus === addressFieldStatus.required}
				options={props.subdivisions?.map(subdivision => ({
					value: subdivision.Id,
					label: subdivision.Name,
				}))}
				disableEditing={props.disableEditing}
				dataTestId={(props.testIdPrefix ?? '') + addressFieldId[props.addressField.id]}
				rules={[
					{
						required: fieldStatus === addressFieldStatus.required,
						message: props.validationMessages?.required,
					},
				]}
				label={t(props.addressField.localizationKey)}
			/>
		</Col>
	);
};

export interface GetInputFieldProps {
	addressInfo: BillingInfo;
	addressField: AddressField;
	validationMessages?: ValidationMessages;
	toolTipText?: string;
	disableEditing?: boolean;
	error?: boolean;
	testIdPrefix?: string;
}

export const GetInputAddressField = (props: GetInputFieldProps) => {
	const dependencies = getRequiredFields(props.addressField, props.addressInfo);
	const fieldStatus = getAddressFieldStatus(props.addressField, dependencies);

	if (fieldStatus === addressFieldStatus.hidden) {
		return null;
	}

	return (
		<Col span={props.addressField.colWidth}>
			<Form.Item
				name={props.addressField.id}
				label={t(props.addressField.localizationKey)}
				htmlFor={`${props.testIdPrefix || ''}${props.addressField.id}`}
				rules={[
					{
						required: fieldStatus === addressFieldStatus.required,
						message: props.validationMessages?.required,
					},
				]}
				style={{ width: '100%' }}
				required={fieldStatus === addressFieldStatus.required}
				tooltip={props.toolTipText}
				{...(props.error
					? {
							validateStatus: 'error',
							help: props.validationMessages?.invalid,
					  }
					: {})}
			>
				<Input
					id={`${props.testIdPrefix || ''}${props.addressField.id}`}
					disabled={props.disableEditing}
					data-testid={(props.testIdPrefix ?? '') + addressFieldId[props.addressField.id]}
				/>
			</Form.Item>
		</Col>
	);
};
